import React from 'react';
import { Box, Typography } from '@mui/material';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import { ESRI_UPDATE_NOTE } from '../../constants/esriDataVintage';

/**
 * Small, unobtrusive caption noting when the ESRI demographic data was last
 * refreshed and which years the current/projection figures represent. Drop it
 * near ESRI-derived numbers (AI summaries, Geographic/Competitive explorers) so
 * users can connect the figures to the data vintage.
 *
 * Wording is centralized in constants/esriDataVintage.js (ESRI_UPDATE_NOTE).
 */
const EsriUpdateNote = ({ align = 'center', sx = {} }) => (
  <Box
    sx={{
      display: 'flex',
      alignItems: 'center',
      justifyContent: align === 'center' ? 'center' : 'flex-start',
      gap: 0.5,
      ...sx,
    }}
  >
    <InfoOutlinedIcon sx={{ fontSize: '0.9rem', color: 'text.secondary' }} />
    <Typography variant="caption" color="text.secondary" sx={{ fontStyle: 'italic' }}>
      {ESRI_UPDATE_NOTE}
    </Typography>
  </Box>
);

export default EsriUpdateNote;
